var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 10.3333H15.8333V7.83333C15.8333 6.91319 15.5078 6.1276 14.8568 5.47656C14.2057 4.82552 13.4201 4.5 12.5 4.5C11.5799 4.5 10.7943 4.82552 10.1432 5.47656C9.49219 6.1276 9.16667 6.91319 9.16667 7.83333V10.3333ZM20 11.5833V19.0833C20 19.4306 19.8785 19.7257 19.6354 19.9688C19.3924 20.2118 19.0972 20.3333 18.75 20.3333H6.25C5.90278 20.3333 5.60764 20.2118 5.36458 19.9688C5.12153 19.7257 5 19.4306 5 19.0833V11.5833C5 11.2361 5.12153 10.941 5.36458 10.6979C5.60764 10.4549 5.90278 10.3333 6.25 10.3333H6.66667V7.83333C6.66667 6.23611 7.23958 4.86458 8.38542 3.71875C9.53125 2.57292 10.9028 2 12.5 2C14.0972 2 15.4687 2.57292 16.6146 3.71875C17.7604 4.86458 18.3333 6.23611 18.3333 7.83333V10.3333H18.75C19.0972 10.3333 19.3924 10.4549 19.6354 10.6979C19.8785 10.941 20 11.2361 20 11.5833Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c882af7657e0049009cdebbdc4ceef6e.svg";
export { ForwardRef as ReactComponent };